import { render, staticRenderFns } from "./k-role-input.vue?vue&type=template&id=2dba8b86&"
import script from "./k-role-input.vue?vue&type=script&lang=ts&"
export * from "./k-role-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports